import {Component, EventEmitter, Input, OnInit, Output, OnDestroy, HostListener} from '@angular/core';
import {IconComponent} from '../icon/icon.component';
import {Icons} from '../../../model/icon';
import {TextsComponent} from '../texts/texts.component';
import {text} from '../../../functions/localization';
import {Card} from '../../../model/cards';
import {ScrollService} from '../../../services/scroll-service';
import {HeaderService} from '../../../services/header-service';
import {Router} from '@angular/router';
import {ThemeService} from '../../../services/theme.service';
import {NgIf} from '@angular/common';
import {scrollUp} from '../../../functions/scroll-up';
import {SyncService} from '../../../services/sync-service';
import {Text} from '../../../model/text';

@Component({
  selector: 'app-hotel-cell',
  imports: [
    IconComponent,
    TextsComponent,
    NgIf
  ],
  templateUrl: './hotel-cell.component.html',
  standalone: true,
  styleUrl: './hotel-cell.component.scss'
})
export class HotelCellComponent implements OnInit, OnDestroy {
  constructor(
    private scroll: ScrollService,
    protected interfaceService: HeaderService,
    private router: Router,
    public themeService: ThemeService,
    private syncService: SyncService) {}

  @Input() card: Card = new Card({
    img: 'app/assets/images/hotel.png',
    title: [],
    text: ['Капелла Бангкок', 'Capella Bangkok'],
    button: false,
    style: '',
  });
  @Input() index: number = 0;
  @Input() classicCursor: boolean = false;
  @Input() cardsLength: boolean = false;
  @Input() firstArray: boolean = true;
  @Output() clickOn = new EventEmitter();

  isMobile: boolean = false;
  buttonTexts: Text[] = [];

  private startPosition: { x: number, y: number } | null = null;
  private wasDragging: boolean = false;
  private readonly DRAG_THRESHOLD = 5;

  ngOnInit() {
    if (this.card.anotherHotelText !== undefined) {
      this.buttonTexts = this.card.anotherHotelText;
    }
    if (window.innerWidth < 770) {
      this.isMobile = true;
    }
    this.interfaceService.setActiveInterface('header-transparent');
    this.card.anotherHotelButton = true;
    this.card.anotherButton = true;
  }

  ngOnDestroy() {}

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.startPosition = { x: event.clientX, y: event.clientY };
    this.wasDragging = false;
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.startPosition) return;

    const deltaX = Math.abs(event.clientX - this.startPosition.x);
    const deltaY = Math.abs(event.clientY - this.startPosition.y);

    if (deltaX > this.DRAG_THRESHOLD || deltaY > this.DRAG_THRESHOLD) {
      this.wasDragging = true;
    }
  }

  @HostListener('mouseup')
  onMouseUp() {
    setTimeout(() => {
      this.startPosition = null;
      this.wasDragging = false;
    }, 50);
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    const touch = event.touches[0];
    this.startPosition = { x: touch.clientX, y: touch.clientY };
    this.wasDragging = false;
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    if (!this.startPosition) return;

    const touch = event.touches[0];
    const deltaX = Math.abs(touch.clientX - this.startPosition.x);
    const deltaY = Math.abs(touch.clientY - this.startPosition.y);

    if (deltaX > this.DRAG_THRESHOLD || deltaY > this.DRAG_THRESHOLD) {
      this.wasDragging = true;
    }
  }

  @HostListener('touchend')
  onTouchEnd() {
    setTimeout(() => {
      this.startPosition = null;
      this.wasDragging = false;
    }, 50);
  }

  openObject() {
    if (this.wasDragging) {
      return;
    }

    if (this.isMobile) {
      return;
    }
    if (this.card.link != undefined) {
      this.syncService.setSlideIndexForce(this.index);
      scrollUp();
      if (this.card.link === 'mock') {
        return;
      }
      this.interfaceService.setActiveInterface('header-transparent');
      this.router.navigate(['/' + this.card.link]).then(r => r);
    }
  }

  openObjectMobile() {
    if (this.wasDragging) {
      return;
    }

    if (!this.isMobile) {
      return;
    }
    if (this.card.link != undefined) {
      this.syncService.setSlideIndexForce(this.index);
      scrollUp();
      if (this.card.link === 'mock') {
        return;
      }
      this.interfaceService.setActiveInterface('header-transparent');
      this.router.navigate(['/' + this.card.link]).then(r => r);
    }
  }

  get cursor() {
    return `url("../../../assets/icons/scroller-cursor.svg") 45 45, auto;`
  }

  formatSlug(text: string) {
    return text
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]/g, '');
  }

  getRatingLabel() {
    switch(this.card.rating) {
      case 1: return `1st place`;
      case 2: return `2nd place`;
      case 3: return `3rd place`;
      default: return `${this.card.rating}th place`;
    }
  }

  get buttonText() {
    if (this.card.anotherHotelButton !== undefined && this.card.anotherHotelText !== undefined) {
      return this.card.anotherHotelText
    }
    const text: Text[] = [{text: ['Детали', 'Details']}]
    return text
  }

  get mobStyle() {
    if (!this.isMobile) {
      return ''
    }
    if (this.firstArray) {
      return `calc(90vh - 160px)`
    }
    return `98vh`
  }

  protected readonly Icons = Icons;
  protected readonly text = text;
}
